import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import MarkdownEditor from "../MarkdownEditor";

interface Props {
  content: string;
  isEditing?: boolean;
  editedContent?: string;
  onEditedContentChange?: (v: string) => void;
}

export default function JobDescriptionTab({
  content,
  isEditing = false,
  editedContent,
  onEditedContentChange,
}: Props) {
  if (isEditing) {
    return (
      <div className="py-6">
        <MarkdownEditor
          value={editedContent ?? content}
          onChange={onEditedContentChange ?? (() => {})}
        />
      </div>
    );
  }

  return (
    <div className="py-6 max-w-none">
      <div className="prose prose-slate dark:prose-invert max-w-none [&_a]:text-[#0000F5] [&_a]:underline">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      </div>
    </div>
  );
}
